import React from 'react';
import Method from "../components/Method";
import Attributes from "../components/Attributes";
import Layout from "../layout";
import {Helmet} from "react-helmet";
import { useTranslation } from 'react-i18next';

const RatesBoth = (props) => {
    const { t, i18n } = useTranslation();

    return (
        <Layout children={props.children} location={props.location}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{t('docs.rates.title')}</title>
                <meta name="description" content="Integrate your website with our carrier rates API. Check rates from multiple carrier starting from GRAB, Gojek, JNE, FedEx and more!" />
                <link rel="canonical" href="https://biteship.com/docs/api/rates" />
            </Helmet>
            <div className="row">
                <div className="col-md-8">
                    <h1>{t('docs.rates.retrieveRatesBy')} {t('docs.rates.mix')}</h1>
                    <br/>
                    <p>{t('docs.rates.mixDesc')} </p>
                    <Method title={"ENDPOINTS"}>
                        <p><b className="text-success">POST</b> /v1/rates/couriers</p>
                    </Method>
                    <br/>
                </div>
            </div>
            <hr/>
            <div className="row">
                <div className="col-md-8">
                    <h2 className="h3">Parameters</h2>
                    <br/>
                    <Attributes data={parameters}/>
                    <br/>
                    <Method title={"JSON BODY"}>
                        <text>{`{`}</text><br/>
                        <text className="pl-4">"origin_postal_code": <text className="text-success">10110</text>,</text><br/>
                        <text className="pl-4">"destination_latitude": <text className="text-success">-6.27167172</text>,</text><br/>
                        <text className="pl-4">"destination_longitude": <text className="text-success">106.74501881</text>,</text><br/>
                        <text className="pl-4">"couriers": <text className="text-swift-pink">"jne,gojek,grab,jet,sicepat"</text>,</text><br/>
                        <text className="pl-4">"items": [</text><br/>
                        <text className="pl-4"><text className="pl-4"/>{`{`}</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"name": <text className="text-swift-pink">"Book"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"description": <text className="text-swift-pink">"Zero to One"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"length": <text className="text-success">10</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"width": <text className="text-success">25</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"height": <text className="text-success">20</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"weight": <text className="text-success">1000</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"quantity": <text className="text-success">2</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"value": <text className="text-success">149000</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/>{`}`},</text><br/>
                        <text className="pl-4"><text className="pl-4"/>{`{...}`},</text><br/>
                        <text className="pl-4"><text className="pl-4"/>{`{...}`}</text><br/>
                        <text className="pl-4">{`]`}</text><br/>
                        <text>{`}`}</text><br/>
                    </Method>
                    <br/>
                    <p>
                        The courier object sent from Biteship will look like following
                    </p>
                    <Method title={"RESPONSE"} white>
                        <text>{`{`}</text><br/>
                        <text className="pl-4">"success": <text className="text-swift-pink"><b>true</b></text>,</text><br/>
                        <text className="pl-4">"object": <text className="text-primary">"courier_rates"</text>,</text><br/>
                        <text className="pl-4">"origin": {`{`}</text><br/>
                        <text className="pl-4"><text className="pl-4"/>"latitude": null,</text><br/>
                        <text className="pl-4"><text className="pl-4"/>"longitude": null,</text><br/>
                        <text className="pl-4"><text className="pl-4"/>"postal_code": <text className="text-success">10110</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"country_name": <text className="text-primary">"Indonesia"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"country_code": <text className="text-primary">"IDN"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_1_name": <text className="text-primary">"DKI Jakarta"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_1_type": <text className="text-primary">"province"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_2_name": <text className="text-primary">"Jakarta Pusat"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_2_type": <text className="text-primary">"city"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_3_name": <text className="text-primary">"Gambir"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_3_type": <text className="text-primary">"district"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_4_name": <text className="text-primary">"Gambir"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_4_type": <text className="text-primary">"subdistrict"</text></text><br/>
                        <text className="pl-4">{`}`},</text><br/>
                        <text className="pl-4">"destination": {`{`}</text><br/>
                        <text className="pl-4"><text className="pl-4"/>"latitude": <text className="text-success">-6.27167172</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/>"longitude": <text className="text-success">106.74501881</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"postal_code": <text className="text-success">12330</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"country_name": <text className="text-primary">"Indonesia"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"country_code": <text className="text-primary">"IDN"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_1_name": <text className="text-primary">"DKI Jakarta"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_1_type": <text className="text-primary">"province"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_2_name": <text className="text-primary">"Jakarta Selatan"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_2_type": <text className="text-primary">"city"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_3_name": <text className="text-primary">"Pesanggrahan"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_3_type": <text className="text-primary">"district"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_4_name": <text className="text-primary">"Bintaro"</text></text>,<br/>
                        <text className="pl-4"><text className="pl-4"/>"administrative_division_level_4_type": <text className="text-primary">"subdistrict"</text></text><br/>
                        <text className="pl-4">{`}`},</text><br/>
                        <text className="pl-4">"pricing": [</text><br/>
                        <text className="pl-4"><text className="pl-4"/>{`{`}</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"courier_name": <text className="text-primary">"GOJEK"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"courier_code": <text className="text-primary">"gojek"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"courier_service_name": <text className="text-primary">"Instant"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"courier_service_code": <text className="text-primary">"instant"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"description": <text className="text-primary">"Instant service for on demand needs."</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"service_type": <text className="text-primary">"same_day"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"shipping_type": <text className="text-primary">"parcel"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"shipment_duration_range": <text className="text-primary">"1 - 2"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"shipment_duration_unit": <text className="text-primary">"hours"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"price": <text className="text-success">54000</text></text><br/>
                        <text className="pl-4"><text className="pl-4"/>{`}`},</text><br/>
                        <text className="pl-4"><text className="pl-4"/>{`{`}</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"courier_name": <text className="text-primary">"JNE"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"courier_code": <text className="text-primary">"jne"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"courier_service_name": <text className="text-primary">"REG"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"courier_service_code": <text className="text-primary">"reg"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"description": <text className="text-primary">"Regular shipment"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"service_type": <text className="text-primary">"standard"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"shipping_type": <text className="text-primary">"parcel"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"shipment_duration_range": <text className="text-primary">"2 - 3"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"shipment_duration_unit":<text className="text-primary"> "days"</text>,</text><br/>
                        <text className="pl-4"><text className="pl-4"/><text className="pl-4"/>"price": <text className="text-success">9000</text></text><br/>
                        <text className="pl-4"><text className="pl-4"/>{`}`},</text><br/>
                        <text className="pl-4"><text className="pl-4"/>{`{...}`},</text><br/>
                        <text className="pl-4"><text className="pl-4"/>{`{...}`}</text><br/>
                        <text className="pl-4">{`]`}</text><br/>
                        <text>{`}`}</text><br/>
                    </Method>
                </div>
            </div>
            <br/>
            <br/>
            <div className="row">
                <div className="col-md-8">
                    <p className="text-muted"><b>Mengenai API Cek Ongkir</b></p>
                    <p className="text-muted">Gunakan API Cek Ongkir atau API Cek Ongkos Kirim Biteship untuk memudahkan pengiriman Anda sehari-hari. API Cek Ongkir Biteship telat terintegrasi dengan berbagai macam kuir, mulai dari kurir instant sampai kurir trucking. API Cek Ongkir Biteship sangat berguna jika Anda memiliki platform atau website yang menawarkan berbagai macam kurir, karena API Cek Onkir Biteship menawarkan mulai dari pengiriman dalam negri dan juga ke luar negri. Anda dapat melihat Dokumentasi API Cek Ongkir Biteship secara lengkap melalui halaman ini. </p>
                </div>
            </div>
            <br/>
            <br/>
        </Layout>
    )
};

const parameters = [{
    name:'origin_latitude',
    type:'double',
    required:true,
    description:'The latitude of the origin'
},{
    name:'origin_longitude',
    type:'double',
    required:true,
    description:'The longitude of the origin'
},{
    name:'origin_postal_code',
    type:'integer',
    required:true,
    description:'The postal code of the origin'
},{
    name:'destination_latitude',
    type:'double',
    required:true,
    description:'The latitude of the destination'
},{
    name:'destination_longitude',
    type:'double',
    required:true,
    description:'The longitude of the destination'
},{
    name:'destination_postal_code',
    type:'integer',
    required:true,
    description:'The postal code of the destination'
},{
    name: 'couriers',
    type: 'string',
    required:true,
    description: 'Courier codes. You can find the courier code in our courier list API'
},{
    name: 'items',
    type: 'array',
    description: 'Service category for the courier',
    items: [{
        name:'name',
        type:'string',
        description:'Name of the goods'
    },{
        name:'description',
        type:'string',
        description:'Description of the goods'
    },{
        name:'length',
        type:'string',
        description:'Length of the goods by centi meters'
    },{
        name:'width',
        type:'string',
        description:'Width of the goods by centi meters'
    },{
        name:'height',
        type:'string',
        description:'Height of the goods by centi meters'
    },{
        name:'weight',
        type:'string',
        description:'Weight of the goods by centi meters'
    },{
        name:'value',
        type:'string',
        description:'Value of the goods'
    }]
}];

export default RatesBoth
